import { CustomMeal } from './CustomMeal';

export class User {
  constructor(data = {}) {
    this.id = data.id || '';
    this.name = data.name || '';
    this.joinedproposals = data.joinedproposals || [];
    this.friends = data.friends || [];
    this.custommeals = data.custommeals || [];
    this.blockedusers = data.blockedusers || [];
    this.fcmtokens = data.fcmtokens || [];
    this.newuserexperience = data.newuserexperience !== undefined ? data.newuserexperience : true;
  }

  getJoinedProposals() {
    return this.joinedproposals;
  }

  setJoinedProposals(joinedproposals) {
    this.joinedproposals = joinedproposals || [];
  }

  getFriends() {
    return this.friends;
  }

  setFriends(friends) {
    this.friends = friends || [];
  }

  getCustomMeals() {
    return this.custommeals.map(mealString => new CustomMeal(mealString));
  }

  setCustomMeals(custommeals) {
    this.custommeals = custommeals || [];
  }

  getCustomMeal(mealId) {
    return this.custommeals.find(meal => meal.id === mealId);
  }

  setCustomMeal(mealId, meal) {
    this.custommeals = this.custommeals.map(meal => meal.id === mealId ? meal : meal);
  }

  getBlockedusers() {
    return this.blockedusers;
  }

  setBlockedusers(blockedusers) {
    this.blockedusers = blockedusers || [];
  }

  isNewuserexperience() {
    return this.newuserexperience;
  }

  setNewuserexperience(newuserexperience) {
    this.newuserexperience = newuserexperience;
  }

  getFcmtokens() {
    return this.fcmtokens;
  }

  setFcmtokens(fcmtokens) {
    this.fcmtokens = fcmtokens || [];
  }

  toMap() {
    return {
      id: this.id,
      name: this.name,
      joinedproposals: [...this.joinedproposals],
      friends: [...this.friends],
      custommeals: [...this.custommeals],
      blockedusers: [...this.blockedusers],
      fcmtokens: [...this.fcmtokens],
      newuserexperience: this.newuserexperience
    };
  }

  toJSON() {
    return JSON.stringify(this.toMap());
  }
} 